import React, { useMemo } from 'react';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import PhoneInput from 'react-phone-number-input';
import store from './../../../../../store';
import { Input, TextField } from '@mui/material';
import { processCountryPhone } from '../../../../../actions/phone';
import { useTranslation } from 'react-i18next';
import { domain } from '../../../../../i18n';

export default ({ input, type, action, meta: { touched, error } }) => {
    const { t } = useTranslation();
    const { info } = store.getState().user;
    const roleId = useMemo(() => {
        return info.role_id;
    }, []);
    const domainLast = domain;
    return (
        <FormControl error={Boolean(touched && error)} variant="filled" fullWidth>
            <TextField {...input} placeholder={t('modals.phone')} type={type} endAdornment={action} />

            {/* {roleId === 10 ? (
      ) : (
        <PhoneInput
          international
          countryCallingCodeEditable={true}
          defaultCountry={processCountryPhone()}
          limitMaxLength
          {...input}
        />
      )} */}

            {touched && error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    );
};
